import * as React from 'react';

import SideBarLink from './SidebarLink';

class SidebarViewStudent extends React.Component {

    render(){
        return(
            <div className="sidebar-view">
                <SideBarLink path='/home' iconName='Home' description='Startside' color="#112f55" fullWidth={true}   />
                <SideBarLink path='/ukeplanstudent' iconName='Calendar' description='Ukeplan elev' title='Ukeplan' />
                <SideBarLink path='/innleveringerstudent' iconName='CompletedSolid' description='Innlevering elev' title='Innlevering'  />
                <SideBarLink path='/timeplanstudent' iconName='ViewAll' description='Timeplan elev' title='Timeplan'  />
                <SideBarLink path='/portefoljestudent' iconName='FabricOpenFolderHorizontal' description='Portefølje for elev' title='Portefølje' />
                <SideBarLink path='/quizstudent' iconName='PageListSolid' description='Prøver' title='Prøver' />
            </div>
        )
    }
}

export default SidebarViewStudent;